<div class="modal-overlay"></div>
<div class="modal-container">
    <div class="modal-header">
        <h4>{{ header }}</h4>
    </div>
    <div class="modal-content">
        <ng-content></ng-content>
    </div>
    <div class="modal-actions">
        <button type="button" class="button-save" (click)="triggerSave()">
            Save <i class="fas fa-save"></i>
        </button>
        <button type="button" class="button-cancel" (click)="triggerCancel()">
            Cancel
        </button>
    </div>
</div>
